import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TeamSection = ({ language }) => {
  const content = {
    en: {
      title: "Meet Our Team",
      subtitle: "Expert professionals dedicated to excellence in coffee trading",
      members: [
      {
        name: "Prof. Hans Ni",
        role: "Head, World Geospatial Information Home; Chairman, AfricCoffee",
        image: "/Hans.png",
        imageAlt: "Professional portrait of Prof. Hans Ni",
        expertise: "Head, World Geospatial Information Home; Chairman, AfricCoffee",
        linkedin: "#"
      },
      {
        name: "Dawit Kassaw",
        role: "Head of Operations, AfricCoffee",
        image: "/Dawit.png",
        imageAlt: "Professional portrait of Dawit Kassaw",
        expertise: "Head of Operations, AfricCoffee",
        linkedin: "#"
      }]

    },
    zh: {
      title: "认识我们的团队",
      subtitle: "致力于咖啡贸易卓越的专业人士",
      members: [
      {
        name: "Hans Ni教授",
        role: "世界地理信息之家负责人；AfricCoffee主席",
        image: "/Hans.png",
        imageAlt: "Hans Ni教授职业肖像",
        expertise: "世界地理信息之家负责人；AfricCoffee主席",
        linkedin: "#"
      },
      {
        name: "Dawit Kassaw",
        role: "世界地理信息之家驻国代表；AfricCoffee运营负责人",
        image: "/Dawit.png",
        imageAlt: "Dawit Kassaw职业肖像",
        expertise: "世界地理信息之家驻国代表；AfricCoffee运营负责人",
        linkedin: "#"
      }]

    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            {content?.[language]?.title}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            {content?.[language]?.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8">
          {content?.[language]?.members?.map((member, index) =>
          <div
            key={index}
            className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-smooth">

              <div className="relative h-64 overflow-hidden">
                <Image
                src={member?.image}
                alt={member?.imageAlt}
                className="w-full h-full object-cover" />

              </div>
              <div className="p-6">
                <h3 className="text-xl font-heading font-semibold text-foreground mb-1">
                  {member?.name}
                </h3>
                <p className="text-sm text-primary font-medium mb-3">
                  {member?.role}
                </p>
                <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                  {member?.expertise}
                </p>
                <a
                href={member?.linkedin}
                className="inline-flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-smooth"
                aria-label={`View ${member?.name}'s LinkedIn profile`}>

                  <Icon name="Linkedin" size={18} />
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TeamSection;